<script>
  import mesesano from '~js/mesesano.js';

  export default {
    props: ['relatorio'],
    data() {
      return {
        mesesano: mesesano,
      }
    },
    methods: {
      nomeMesAno(mesano) {
        mesano = parseInt(mesano);

        if (mesano == null || mesano == undefined || isNaN(mesano))
          mesano = 0

        return this.mesesano.find(m => {
          return m.id === mesano;
        }).sigla;
      },
      retornaSaldo(index) {
        return this.relatorio.slice(0, index + 1).reduce((total, lancamentos) => {
          return total + lancamentos.total;
        }, 0);
      }
    },
    computed: {
      saldoTotal() {
        return this.relatorio.reduce((total, lancamentos) => {
          return total + lancamentos.total;
          }, 0);
      },
    }
  }
</script>

<template>
  <div>
    <table class="table relatorio table-bordered">
      <thead>
        <tr>
          <th>Mês/Ano</th>
          <th>Rendimento/IRRF/IOF</th>
          <th class="text-center">Valor (R$)</th>
          <th class="text-center">Saldo (R$)</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(lancamentos, index) in relatorio">
          <td>{{ nomeMesAno(lancamentos.mes) }}\{{lancamentos.ano}}</td>
          <td>{{ lancamentos.nomeTipoOperacaoAplicacao }}</td>
          <td class="text-center">{{ lancamentos.total | formatarNumero }}</td>
          <td class="text-center">{{ retornaSaldo(index) | formatarNumero }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr style="background-color: #F5F5F6">
          <th class="text-right" colspan="3"></th>
          <th class="text-center">{{ saldoTotal | formatarNumero }}</th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/LancamentoModelo3/Rendimentos.vue